// extracted by mini-css-extract-plugin
export default {"wrapper":"Gx-z","viewport":"Hx-z","container":"Ix-z","slide":"Jx-z"};